import React, { useState, useEffect, useRef } from "react"
import { Col, Container, Row } from "reactstrap"
import { Menu } from "primereact/menu"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import { Sidebar } from "primereact/sidebar"
import { Link } from "react-router-dom"
import { TabView, TabPanel } from "primereact/tabview"
import { Badge } from "primereact/badge"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { FilterMatchMode } from "primereact/api"
import { Dropdown } from "primereact/dropdown"
import { ChevronDownIcon } from "primereact/icons/chevrondown"
import { ChevronRightIcon } from "primereact/icons/chevronright"
import { useNavigate } from "react-router-dom"
import { Accordion, AccordionTab } from "primereact/accordion"
import { InputText } from "primereact/inputtext"
import { Calendar } from 'primereact/calendar';
import { TreeSelect } from 'primereact/treeselect';
import { InputTextarea } from 'primereact/inputtextarea';
import { TreeTable } from 'primereact/treetable';
import axios from "axios"
import { ConfirmationAlert, get_user_menu_permission, simpleAlert, triggerAlert } from "utils/CommonFunctions"

import TableEmailAC from "./TableEmailAC"
import { menuIdData } from "utils/Constants"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"

import AllActiveemp from "ATSComponents/Candidates/AllActiveemp"
import CompanySelector from "ATSComponents/Common/CompanySelector"



const TableView = () => {


  const [addPermission, setAddPermission] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [viewPermission, setViewPermission] = useState(false);

  document.title = "ATS - Candidates Pipeline"

  useEffect(() => {
    const menu_id = menuIdData?.TableView;
    setAddPermission(get_user_menu_permission(menu_id, 'add'));
    setEditPermission(get_user_menu_permission(menu_id, 'edit'));
    setDeletePermission(get_user_menu_permission(menu_id, 'delete'));
    setViewPermission(get_user_menu_permission(menu_id, 'view'));
  }, [])
  // view form pipeline starts

  const [receivedJobsFilters, setReceivedJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    jobid: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    contact: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    company: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const [selectedNewJobs, setSelectedNewJobs] = useState([])

  const newJobs = [
    {
      type: "Interview",
      contact: "Srinivas",
      job_title: "Frontend Developer",
      company: "TCS",
      phone: "9898989898",
      city: "Hyderabad",
      job_id: "Job-101",
      user_id: "srinivas123",
      create_date: "2025-01-21",
      closed_date: "2025-06-23",
    },
    {
      type: "Offer Accepted",
      contact: "Rajesh",
      job_title: "Backend Developer",
      company: "Infosys",
      phone: "9876543210",
      city: "Bangalore",
      job_id: "Job-102",
      user_id: "rajesh456",
      create_date: "2025-02-01",
      closed_date: "2025-07-01",
    },
    {
      type: "Interview",
      contact: "Priya",
      job_title: "Data Analyst",
      company: "Wipro",
      phone: "9123456780",
      city: "Chennai",
      job_id: "Job-103",
      user_id: "priya789",
      create_date: "2025-01-05",
      closed_date: "2025-05-10",
    },
    {
      type: "Offer Accepted",
      contact: "Anil",
      job_title: "Mechanical Engineer",
      company: "L&T",
      phone: "9876512345",
      city: "Pune",
      job_id: "Job-104",
      user_id: "anil321",
      create_date: "2025-03-12",
      closed_date: "2025-08-15",
    },
    {
      type: "Interview",
      contact: "Swetha",
      job_title: "HR Manager",
      company: "Capgemini",
      phone: "9823456701",
      city: "Kolkata",
      job_id: "Job-105",
      user_id: "swetha555",
      create_date: "2025-04-20",
      closed_date: "2025-09-20",
    },
    {
      type: "Offer Accepted",
      contact: "Kiran",
      job_title: "Software Tester",
      company: "Accenture",
      phone: "9845678902",
      city: "Delhi",
      job_id: "Job-106",
      user_id: "kiran333",
      create_date: "2025-05-10",
      closed_date: "2025-10-25",
    },
    {
      type: "Interview",
      contact: "Meera",
      job_title: "Project Manager",
      company: "HCL",
      phone: "9865432109",
      city: "Mumbai",
      job_id: "Job-107",
      user_id: "meera101",
      create_date: "2025-06-15",
      closed_date: "2025-11-30",
    },
    {
      type: "Offer Accepted",
      contact: "Arjun",
      job_title: "UI/UX Designer",
      company: "Adobe",
      phone: "9832104567",
      city: "Noida",
      job_id: "Job-108",
      user_id: "arjun007",
      create_date: "2025-06-25",
      closed_date: "2025-12-15",
    },
    {
      type: "Interview",
      contact: "Nisha",
      job_title: "Cloud Engineer",
      company: "Microsoft",
      phone: "9871234560",
      city: "Gurgaon",
      job_id: "Job-109",
      user_id: "nisha999",
      create_date: "2025-06-30",
      closed_date: "2026-01-10",
    },
    {
      type: "Offer Accepted",
      contact: "Vikram",
      job_title: "AI Engineer",
      company: "Google",
      phone: "9891234567",
      city: "Hyderabad",
      job_id: "Job-110",
      user_id: "vikram001",
      create_date: "2025-07-05",
      closed_date: "2026-01-20",
    },
  ]

  const navigate = useNavigate()

  const [selectedReceivedJobs, setSelectedReceivedJobs] = useState([])

  // potential

  const [potentialJobsFilters, setPotentialJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    jobid: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    contact: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    company: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })



  const [selectedPotentialJobs, setSelectedPotentialJobs] = useState([])

  // submitted
  const [submittedJobsFilters, setSubmittedJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    jobid: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    contact: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    company: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })



  const [selectedSubmittedJobs, setSelectedSubmittedJobs] = useState([])

  // offer

  const [offerJobsFilters, setOfferJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    jobid: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    contact: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    company: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })



  const [selectedOfferJobs, setSelectedOfferJobs] = useState([])

  // rejected

  const [rejectedJobsFilters, setRejectedJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    jobid: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    contact: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    company: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })



  const [selectedRejectedJobs, setSelectedRejectedJobs] = useState([])

  // interview

  const [interviewJobsFilters, setInterviewJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    jobid: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    contact: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    company: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })


  const [selectedInterviewJobs, setSelectedInterviewJobs] = useState([])

  // placed

  const [newJobsFilters, setNewJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.EQUALS },
    contact: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_title: { value: null, matchMode: FilterMatchMode.CONTAINS },
    company: { value: null, matchMode: FilterMatchMode.CONTAINS },
    phone: { value: null, matchMode: FilterMatchMode.CONTAINS },
    city: { value: null, matchMode: FilterMatchMode.CONTAINS },
    job_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    user_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    create_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    closed_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const [placedJobsFilters, setPlacedJobsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    jobid: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    contact: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    company: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    date_time: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })


  const [selectedPlacedJobs, setSelectedPlacedJobs] = useState([])

  // view form pipeline ends

  const [receivedJobs, setreceivedJobs] = useState([])
  const [potentialJobs, setpotentialJobs] = useState([])
  const [submittedJobs, setsubmittedJobs] = useState([])
  const [offerJobs, setofferJobs] = useState([])
  const [interviewJobs, setinterviewJobs] = useState([])
  const [rejectedJobs, setrejectedJobs] = useState([])
  const [placedJobs, setplacedJobs] = useState([])


  const [selectedEmployees, setselectedEmployees] = useState(0);

  const [showStageConfirmDialog, setShowStageConfirmDialog] = useState(false);
  const [pendingStage, setPendingStage] = useState(null);



  // State for dynamic stages
  const [stages, setStages] = useState([]);
  const [stageOptions, setStageOptions] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  // Dynamic state for job data, filters, selections, and badge counts
  const [stageData, setStageData] = useState({});
  const [stageFilters, setStageFilters] = useState({});
  const [stageSelections, setStageSelections] = useState({});
  const [badgeCounts, setBadgeCounts] = useState({});

  // State for pagination
  const [pageStates, setPageStates] = useState({});

  const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));
  const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
  const [companyId, setCompanyId] = useState(intialcompanyId);

  const handleCompanyChange = (company) => {
    if (company?.company_id) {
        setCompanyId(company?.company_id);
        // fetchUserManagementDetails(company.company_i)
        // getDesignation(company.company_id);
    }
  };


  // Fetch stages from API
  const fetchStages = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-stages/?company_id=${companyId}`);
      if (response.data && response.data.results) {
        const fetchedStages = response.data.results;
        setStages(fetchedStages);
        const options = fetchedStages.map((stage) => ({
          label: stage.name,
          icon: getStageIcon(stage.name),
        }));
        setStageOptions(options);

        // Initialize states for each stage
        const initialData = {};
        const initialFilters = {};
        const initialSelections = {};
        const initialBadgeCounts = {};
        const initialPageStates = {};

        fetchedStages.forEach((stage) => {
          initialData[stage.name] = [];
          initialFilters[stage.name] = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            stage: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            candidatename: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            company_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            phone: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            city: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            jobid: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            created_by_name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            job_start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            job_end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          };
          initialSelections[stage.name] = [];
          initialBadgeCounts[stage.name] = 0;
          initialPageStates[stage.name] = { rows: 10, first: 0 };
          setPageStates(initialPageStates);
        });
        setStageData(initialData);
        setStageFilters(initialFilters);
        setStageSelections(initialSelections);
        setBadgeCounts(initialBadgeCounts);
      }
    } catch (error) {
      console.error("Error fetching stages:", error);
      simpleAlert("Failed to fetch stages. Please try again.");
    }
  };

  // Fetch all candidates by stage
  const getAllActiveReceived = async () => {
    try {
      // setLoading(true);
      const response = await axios.get(`/api/v1/stages/job_candidates_by_stage/?company_id=${companyId}`);
      if (response.data && response.data.results) {
        const fetchedStages = response.data.results;
        const newStageData = { ...stageData };
        const newBadgeCounts = { ...badgeCounts };

        const transformCandidates = (candidates) =>
          candidates.map((candidate) => ({
            status: candidate.job?.job_status_name || "N/A",
            job_candidate_id: candidate.job_candidate_id,
            candidate: candidate.candidate,
            candidatename: candidate.candidate_name,
            company_id: candidate.current_company,
            city: candidate.city,
            phone: candidate.phone,
            jobid: candidate.job.job_number,
            job_title: candidate.job.job_title,
            contact: candidate.candidate_email,
            date_time: candidate.applied_date,
            created_by_name: candidate.created_by_meta ? candidate.created_by_meta : candidate.created_by_name || "N/A",
            job_start_date: candidate.job?.job_start_date || "N/A",
            job_end_date: candidate.job?.job_end_date || "N/A",
            stage: candidate.stage || "N/A",
            candidate_email: candidate.candidate_email || "N/A"
          }));

        fetchedStages.forEach((stage) => {
          newStageData[stage.stage_name] = transformCandidates(stage.candidates || []);
          newBadgeCounts[stage.stage_name] = stage.count || 0;
        });

        setStageData(newStageData);
        setBadgeCounts(newBadgeCounts);
      }
    } catch (error) {
      console.error("Error fetching candidate data:", error);
      simpleAlert("Failed to fetch candidate data. Please try again.");
    }
  };

  // Get stage icon
  const getStageIcon = (stageName) => {
    const icons = {
      Received: "pi pi-inbox",
      Potential: "pi pi-star",
      Submitted: "pi pi-send",
      Interviews: "pi pi-users",
      "Offer Accepted": "pi pi-thumbs-up",
      "Offer Rejected": "pi pi-thumbs-down",
      "Placement Closed": "pi pi-check-circle",
    };
    return icons[stageName] || "pi pi-cog";
  };


  // Handle stage change
  const handleStageChange = (newStage) => {
    if (!newStage) return;

    // Store the pending stage and show confirmation dialog
    setPendingStage(newStage);
    setShowStageConfirmDialog(true);
  };


  // Confirm stage change
  const confirmStageChange = async () => {
    if (!pendingStage) {
      setShowStageConfirmDialog(false);
      return;
    }

    const currentStage = stages[activeTabIndex]?.name;
    const selectedCandidates = stageSelections[currentStage] || [];

    if (selectedCandidates.length === 0) {
      simpleAlert("Please select at least one candidate to change the stage.");
      setShowStageConfirmDialog(false);
      return;
    }

    const candidateIds = selectedCandidates.map((candidate) => candidate.job_candidate_id).join(",");

    try {
      await axios.put(`/api/v1/change-stage/${candidateIds}/`, { stage: pendingStage.label });
      await getAllActiveReceived();
      setStageSelections((prev) => ({ ...prev, [currentStage]: [] }));
      setShowIconsSelect(false);
      setSelectedSmsOption1(null);
      triggerAlert("success", "Success", "Stage Updated Successfully!");
    } catch (error) {
      console.error("Error changing stage:", error);
      simpleAlert("Failed to change stage. Please try again.");
    } finally {
      setShowStageConfirmDialog(false);
      setPendingStage(null);
    }
  };

  const cancelStageChange = () => {
    // Close the dialog and reset pending stage
    setShowStageConfirmDialog(false);
    setPendingStage(null);
    setSelectedSmsOption1(null);
  };


  const [showIconsSelect, setShowIconsSelect] = useState(false);
  // const [showIconspotential, setshowIconspotential] = useState(false);
  // const [showesitSelect, setshowesitSelect] = useState(true);
  // const [showesitSelecticon, setshowesitSelecticon] = useState(false);


  // Handle selection change
  const onSelectionChange = (stageName) => (e) => {
    const selected = e.value || [];
    setStageSelections((prev) => ({ ...prev, [stageName]: selected }));
    setShowIconsSelect(selected.length > 1);
  };


  // const onSelectionChangepotential = (e) => {
  //   const selected = e.value || [];
  //   setSelectedPotentialData(selected);
  //   setShowIconsSelect(selected.length > 1);
  // };

  // const onSelectionChangesubmit = (e) => {
  //   const selected = e.value || [];
  //   setSelectSubmittedData(selected);
  //   setShowIconsSelect(selected.length > 1);
  // };

  // const onSelectionChangeInterview = (e) => {
  //   const selected = e.value || [];
  //   setSelectedInterviewData(selected);
  //   setShowIconsSelect(selected.length > 1);
  // };

  // const onSelectionChangeOfferAccepted = (e) => {
  //   const selected = e.value || [];
  //   setSelectedOfferAcceptedData(selected);
  //   setShowIconsSelect(selected.length > 1);
  // };

  // const onSelectionChangeOfferRejected = (e) => {
  //   const selected = e.value || [];
  //   setSelectedOfferRejectedData(selected);
  //   setShowIconsSelect(selected.length > 1);
  // };

  // const onSelectionChangePlacementClosed = (e) => {
  //   const selected = e.value || [];
  //   setSelectedPlacementClosed(selected);
  //   setShowIconsSelect(selected.length > 1);
  // };




  //   Received start

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    candidatename: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    company_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    city: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    phone: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    city: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    jobid: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    user_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    job_end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  })

  const [selectSubmittedData, setSelectSubmittedData] = useState([])
  const [selectedInterviewData, setSelectedInterviewData] = useState([])
  const [selectedOfferAcceptedData, setSelectedOfferAcceptedData] = useState([])
  const [selectedOfferRejectededData, setSelectedOfferRejectedData] = useState([])
  const [selectedPlacementClosed, setSelectedPlacementClosed] = useState([])


  const [selectedTableData, setSelectedTableData] = useState([])
  const [selectedPotentialData, setSelectedPotentialData] = useState([])
  const [loading, setLoading] = useState(false)
  const [pageState, setPageState] = useState({ rows: 10, first: 0 })


  // Handle page change
  const onPage = (stageName) => (event) => {
    setPageStates((prev) => ({ ...prev, [stageName]: { rows: event.rows, first: event.first } }));
  };

  const dt = useRef(null)

  const exportCSV = selectionOnly => {
    dt.current.exportCSV({ selectionOnly })
  }

  //   Delete the selected data start

  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

  const handleDeleteSelected = () => {
    setShowConfirmDialog(true)
  }
  const [successAlert, setsuccessAlert] = useState(false)

  // Handle delete selected
  const confirmDelete = async () => {
    const currentStage = stages[activeTabIndex]?.name;
    const selectedCandidates = stageSelections[currentStage] || [];

    if (selectedCandidates.length === 0) {
      simpleAlert("Please select at least one candidate to delete.");
      setShowConfirmDialog(false);
      return;
    }

    const candidateIds = selectedCandidates.map((candidate) => candidate.job_candidate_id).join(",");

    try {
      await axios.delete(`/api/v1/candidate-job-links/${candidateIds}/`);
      await getAllActiveReceived();
      setStageSelections((prev) => ({ ...prev, [currentStage]: [] }));
      // setSuccessAlert(true);
      triggerAlert("success", "Success", "Candidate Delete Successfully!")
    } catch (error) {
      console.error("Error deleting candidates:", error);
      simpleAlert("Failed to delete candidates. Please try again.");
    } finally {
      setShowConfirmDialog(false);
    }
  };

  // Cancel delete
  const cancelDelete = () => {
    setShowConfirmDialog(false);
  };

  // Delete selected job-links end



  //   Received end

  //   acton items start

  // email
  const [selectedEmailOption, setSelectedEmailOption] = useState(null)
  const emailOptionsdrop = [
    { label: "New Email", icon: "pi pi-envelope" },
    { label: "Selected", icon: "pi pi-check-circle" },
    { label: "Searched", icon: "pi pi-search" },
    { label: "All", icon: "pi pi-inbox" },
    { label: "Jobs", icon: "pi pi-briefcase" },
  ]

  const handleEmailChange = (value) => {
    setSelectedEmailOption(value);
  };

  const selectedEmailTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-envelope mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const emailOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }


  //   sms

  const [selectedSmsOption, setSelectedSmsOption] = useState(null)
  const smsOptions = [
    { label: "Selected", icon: "pi pi-check-circle" },
    { label: "Searched", icon: "pi pi-search" },
    { label: "All", icon: "pi pi-inbox" },
  ]

  const selectedSmsTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-comment mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const smsOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }

  //   change status

  const [selectedSmsOption1, setSelectedSmsOption1] = useState(null)
  // const smsOptions1 = [
  //   { label: "Received", icon: "pi pi-inbox" },
  //   { label: "Screening", icon: "pi pi-search" },
  //   { label: "Shortlist", icon: "pi pi-list" },
  //   { label: "Potential", icon: "pi pi-star" },
  //   { label: "Interview", icon: "pi pi-users" },
  //   { label: "System Test", icon: "pi pi-desktop" },
  //   { label: "Selected", icon: "pi pi-check" },
  //   { label: "Rejected", icon: "pi pi-times" },
  //   { label: "HR Discussion", icon: "pi pi-comments" },
  //   { label: "Offer Accepted", icon: "pi pi-thumbs-up" },
  //   { label: "Offer Rejected", icon: "pi pi-thumbs-down" },
  //   { label: "Onboarding", icon: "pi pi-user-plus" },
  // ]

  const selectedSmsTemplate1 = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <i className={`${option.icon} mr-2`}></i>
          <div>{option.label}</div>
        </div>
      )
    }
    return (
      <div className="flex align-items-center">
        <i className="pi pi-comment mr-2"></i>
        <span>{props.placeholder}</span>
      </div>
    )
  }

  const smsOptionTemplate1 = option => {
    return (
      <div className="flex align-items-center">
        <i className={`${option.icon} mr-2`}></i>
        <div>{option.label}</div>
      </div>
    )
  }

  //   sidebar start

  const [visibleViewRight, setVisibleViewRight] = useState(false)
  const [fullName, setFullName] = useState("")
  const [city, setCity] = useState("")
  const [jobTitle, setJobTitle] = useState("")
  const [company, setCompany] = useState("")
  const [userIds, setUserIds] = useState("")
  const [availabilityDate1, setavailabilityDate1] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [workEmail, setWorkEmail] = useState("")
  const [documents, setDocuments] = useState([])
  const [description, setDescription] = useState("")
  const [primarySkills, setPrimarySkills] = useState(null)
  const [isEditorVisible, setEditorVisible] = useState(false);
  const [candidateNotes, setCandidateNotes] = useState([]);


  //   clear search fields start

  // Handle clear search
  const handleClearSearch = (stageName) => () => {
    setStageFilters((prev) => ({
      ...prev,
      [stageName]: {
        type: { value: "", matchMode: "contains" },
        candidatename: { value: "", matchMode: "contains" },
        job_title: { value: "", matchMode: "contains" },
        company_id: { value: "", matchMode: "contains" },
        phone: { value: "", matchMode: "contains" },
        city: { value: "", matchMode: "contains" },
        jobid: { value: "", matchMode: "contains" },
        user_id: { value: "", matchMode: "contains" },
        job_start_date: { value: "", matchMode: "contains" },
        job_end_date: { value: "", matchMode: "contains" },
      },
    }));
    setPageState((prev) => ({ ...prev, first: 0 }));
  };

  // Handle filter change
  const handleFilterChange = (stageName) => (e) => {
    setStageFilters((prev) => ({ ...prev, [stageName]: e.filters }));
  };


  const [receivedJobs1, setreceivedJobs1] = useState([])
  const [potentialJobs1, setpotentialJobs1] = useState([])
  const [submittedJobs1, setsubmittedJobs1] = useState([])
  const [offerJobs1, setofferJobs1] = useState([])
  const [interviewJobs1, setinterviewJobs1] = useState([])
  const [rejectedJobs1, setrejectedJobs1] = useState([])
  const [placedJobs1, setplacedJobs1] = useState([])
  const [badgeCounts1, setBadgeCounts1] = useState({
    Received: 0,
    Potential: 0,
    Submitted: 0,
    Interview: 0,
    Offer: 0,
    Placed: 0,
    Rejected: 0
  });


  const getcondidatepipeline = async (candidate) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/stages/job_candidates_by_stage/?candidate_id=${candidate}`, {});

      if (response.data) {
        const stages = response.data.results;

        setBadgeCounts1({
          Received: stages.find(stage => stage.stage_name === "Received")?.count || 0,
          Potential: stages.find(stage => stage.stage_name === "Potential")?.count || 0,
          Submitted: stages.find(stage => stage.stage_name === "Submitted")?.count || 0,
          Interview: stages.find(stage => stage.stage_name === "Interviews")?.count || 0,
          Offer: stages.find(stage => stage.stage_name === "Offer Accepted")?.count || 0,
          Placed: stages.find(stage => stage.stage_name === "Placement Closed")?.count || 0,
          Rejected: stages.find(stage => stage.stage_name === "Offer Rejected")?.count || 0,
        });

        // Helper function to transform candidates
        const transformCandidates = (candidates) =>
          candidates.map((candidate) => ({
            status: candidate.status,
            job_candidate_id: candidate.job_candidate_id,
            candidate: candidate.candidate,
            candidatename: candidate.candidate_name,
            company_id: candidate.current_company,
            jobid: candidate.job.job_id,
            job_title: candidate.job.job_title,
            contact: candidate.candidate_email,
            date_time: candidate.applied_date,
            user_id: candidate.user_ids,
            job_start_date: candidate.job?.start_date,
            job_end_date: candidate.job?.end_date,
          }));

        // Find and transform data for each stage
        const receivedJobs = transformCandidates(
          stages.find((stage) => stage.stage_name === "Received")?.candidates || []
        );
        const potentialJobs = transformCandidates(
          stages.find((stage) => stage.stage_name === "Potential")?.candidates || []
        );
        const submittedJobs = transformCandidates(
          stages.find((stage) => stage.stage_name === "Submitted")?.candidates || []
        );
        const interviewJobs = transformCandidates(
          stages.find((stage) => stage.stage_name === "Interviews")?.candidates || []
        );
        const offer = transformCandidates(
          stages.find((stage) => stage.stage_name === "Offer Accepted")?.candidates || []
        );
        const placed = transformCandidates(
          stages.find((stage) => stage.stage_name === "Placement Closed")?.candidates || []
        );
        const rejected = transformCandidates(
          stages.find((stage) => stage.stage_name === "Offer Rejected")?.candidates || []
        );

        // Update state for each stage
        setreceivedJobs1(receivedJobs);
        setpotentialJobs1(potentialJobs);
        setsubmittedJobs1(submittedJobs);
        setinterviewJobs1(interviewJobs);
        setofferJobs1(offer);
        setrejectedJobs1(rejected);
        setplacedJobs1(placed);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(() => {
    fetchStages()
    getAllActiveReceived()
  }, [])

  const employeeRef = useRef();
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [triggerCandidate, setTriggerCandidate] = useState(false)
  const [viewTriggerVersion, setViewTriggerVersion] = useState(0);


  // 🔘 triggered from button in loop
  const handleTrigger = (stage) => {
    const candidateId = stageSelections[stage.name]?.[0]?.candidate;

    if (!candidateId) {
      simpleAlert("Please select a candidate to view.");
      return;
    }

    setSelectedCandidateId(candidateId);
    setTriggerCandidate(true);
    setViewTriggerVersion(prev => prev + 1); // 👈 always changes
  };

  // 🔁 open modal when AllActiveemp is mounted with correct candidateId
  useEffect(() => {
    if (employeeRef.current && selectedCandidateId) {
      employeeRef.current.openPopup();
    }
  }, [viewTriggerVersion]); // 👈 triggers every time

  

  return (
    <React.Fragment>
      <div className="page-content allact-tabs pipe-table">
        <Container fluid={true}>
          <div className="page-title-box mb-0 recruiter-dashboard actjobsum">
            <Row>
              <Col lg={12}>
                {/* <TabView className="mt-4"> */}
                {/* <TabPanel> */}
                <Row className="view-form-sidebar table-sec">
                  <Col lg={12}>
                    <div className="field mb-2 me-2"  style={{ width: "300px"}}>
                      <label htmlFor="role_id">Company<span className="text-danger">*</span></label>
                      <CompanySelector onCompanyChange={handleCompanyChange} />
                    </div>
                    <div className="pipelinetabs">
                      <TabView scrollable activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
                        {stages.map((stage, index) => (
                          <TabPanel
                            key={stage.name}
                            header={stage.name}
                            rightIcon={
                              <Badge
                                value={badgeCounts[stage.name] || 0}
                                severity="success"
                                className="ml-2"
                              />
                            }
                            leftIcon={`${getStageIcon(stage.name)} mr-1`}
                          >
                            <div>
                              <Row className="align-items-center pt-3 pb-3 breadcrumb-card action-items">
                                <Col md={12} lg={12} className="d-flex align-items-center">
                                  {stageSelections[stage.name]?.length > 0 && (
                                    <>
                                      <button
                                        type="button"
                                        className="btn btn-secondary import-res-btn ms-1 mainbtn me-1"
                                      >
                                        <i className="fa-regular fa-user me-1"></i>
                                        {stageSelections[stage.name].length} Selected
                                      </button>
                                      {showIconsSelect && deletePermission ? (
                                        <button
                                          type="button"
                                          className="btn btn-secondary import-res-btn ms-1 mainbtn"
                                          onClick={() => setShowConfirmDialog(true)}
                                        >
                                          <i className="pi pi-trash"></i>
                                        </button>
                                      ) : (
                                        <>
                                          {viewPermission && (
                                            <button
                                              type="button"
                                              className="btn btn-secondary import-res-btn ms-1 mainbtn"
                                              onClick={() => handleTrigger(stage)}
                                            >
                                              <i className="pi pi-eye"></i>
                                            </button>)}

                                          {editPermission && (
                                            <Link to={`/candidate-editform?candidate_id=${stageSelections[stage.name][0].candidate}`}> <button
                                              type="button"
                                              className="btn btn-secondary import-res-btn ms-1 mainbtn"
                                            // onClick={() => navigate("/candidate-editform")}
                                            >
                                              <i className="pi pi-pencil"></i>
                                            </button></Link>
                                          )}

                                          {deletePermission && (<button
                                            type="button"
                                            className="btn btn-secondary import-res-btn ms-1 mainbtn"
                                            onClick={() => setShowConfirmDialog(true)}
                                          >
                                            <i className="pi pi-trash"></i>
                                          </button>)}

                                        </>
                                      )}
                                    </>
                                  )}

                                  <TableEmailAC selectedData={stageSelections[stage.name] || []} stageName={stage.name} companyId={companyId}  />

                                  {/* <Dropdown
                                    value={selectedSmsOption}
                                    onChange={(e) => setSelectedSmsOption(e.value)}
                                    options={smsOptions}
                                    optionLabel="label"
                                    placeholder="SMS"
                                    valueTemplate={selectedSmsTemplate}
                                    itemTemplate={smsOptionTemplate}
                                    className="action-items me-1"
                                    dropdownIcon={(opts) =>
                                      opts.iconProps["data-pr-overlay-visible"] ? (
                                        <ChevronRightIcon {...opts.iconProps} />
                                      ) : (
                                        <ChevronDownIcon {...opts.iconProps} />
                                      )
                                    }
                                  /> */}

                                  <Dropdown
                                    value={selectedSmsOption1}
                                    onChange={(e) => {
                                      setSelectedSmsOption1(e.value);
                                      handleStageChange(e.value);
                                    }}
                                    options={stageOptions}
                                    optionLabel="label"
                                    placeholder="Change Status"
                                    valueTemplate={selectedSmsTemplate1}
                                    itemTemplate={smsOptionTemplate1}
                                    className="action-items me-1"
                                    dropdownIcon={(opts) =>
                                      opts.iconProps["data-pr-overlay-visible"] ? (
                                        <ChevronRightIcon {...opts.iconProps} />
                                      ) : (
                                        <ChevronDownIcon {...opts.iconProps} />
                                      )
                                    }
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-secondary import-res-btn ms-1 mainbtn mb-1"
                                    onClick={handleClearSearch(stage.name)}
                                  >
                                    <i className="fa-solid fa-xmark"></i> Clear Search
                                  </button>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg={12} className="p-0">
                                  <section className="job-datatable-section">
                                    <div className="card1 mt-3 mb-4 actjobsumtable datatable-check">
                                      {loading ? (
                                        <OrgTableShimmer columns={6} rows={6} titleWidth="220px" />
                                      ) : (
                                        <DataTable
                                          ref={dt}
                                          value={stageData[stage.name] || []}
                                          tableStyle={{
                                            minWidth: "50rem",
                                            borderRadius: "8px",
                                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                                          }}
                                          rows={pageStates[stage.name]?.rows || 10}
                                          first={pageStates[stage.name]?.first || 0}
                                          totalRecords={badgeCounts[stage.name]}
                                          paginator
                                          rowsPerPageOptions={[5, 10, 25, 50, 100, 150]}
                                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                          onPage={onPage(stage.name)}
                                          dataKey="job_candidate_id"
                                          scrollable
                                          emptyMessage="No records found."
                                          selection={stageSelections[stage.name]}
                                          onSelectionChange={onSelectionChange(stage.name)}
                                          filters={stageFilters[stage.name]}
                                          selectionMode="checkbox"
                                          onFilter={handleFilterChange(stage.name)}
                                          filterDisplay="row"
                                          reorderableRows
                                          resizableColumns
                                          columnResizeMode="expand"
                                        >
                                          <Column selectionMode="multiple" headerStyle={{ width: "3em" }} />
                                          <Column field="stage" header="Stage Name" sortable filter style={{ minWidth: "10rem" }} />
                                          <Column field="candidatename" header="Full Name" sortable filter style={{ minWidth: "10rem" }} />
                                          <Column field="job_title" header="Job Title" sortable filter style={{ minWidth: "12rem" }} />
                                          <Column field="company_id" header="Company Name" sortable filter style={{ minWidth: "12rem" }} />
                                          <Column field="status" header="Job Status" sortable filter style={{ minWidth: "12rem" }} />
                                          <Column field="phone" header="Phone" sortable filter style={{ minWidth: "12rem" }} />
                                          <Column field="city" header="City" sortable filter style={{ minWidth: "12rem" }} />
                                          <Column field="jobid" header="Job ID" sortable filter style={{ minWidth: "12rem" }} />
                                          <Column field="created_by_name" header="Created By Name" sortable filter style={{ minWidth: "10rem" }} />
                                          <Column field="job_start_date" header="Start Date" sortable filter style={{ minWidth: "12rem" }} />
                                          <Column field="job_end_date" header="End Date" sortable filter style={{ minWidth: "12rem" }} />
                                        </DataTable>
                                      )}
                                      <Dialog
                                        visible={showConfirmDialog}
                                        style={{ width: "450px" }}
                                        header="Confirm Deletion"
                                        modal
                                        onHide={() => setShowConfirmDialog(false)}
                                      >
                                        <p>Are you sure you want to delete?</p>
                                        <div>
                                          <button type="button" className="btn btn-secondary" onClick={cancelDelete}>
                                            Cancel
                                          </button>
                                          <button type="button" className="btn btn-danger ms-2" onClick={confirmDelete}>
                                            Delete
                                          </button>
                                        </div>
                                      </Dialog>
                                    </div>
                                  </section>
                                </Col>
                              </Row>

                              {triggerCandidate && <AllActiveemp ref={employeeRef} id={selectedCandidateId} />}
                            </div>
                          </TabPanel>
                        ))}
                      </TabView>
                    </div>
                  </Col>
                </Row>
                {/* </TabPanel> */}
                {/* </TabView> */}
              </Col>
            </Row>

            {/* New Stage Change Confirmation Dialog */}
            <Dialog
              visible={showStageConfirmDialog}
              style={{ width: "450px" }}
              header="Confirm Stage Change"
              modal
              onHide={cancelStageChange}
            >
              <p>
                Are you sure you want to change the stage to{" "}
                <strong>{pendingStage?.label}</strong> for the selected candidate(s)?
              </p>
              <div>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={cancelStageChange}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary ms-2"
                  onClick={confirmStageChange}
                >
                  Confirm
                </button>
              </div>
            </Dialog>

            {/* view employee start */}
            <Row>
              <Col lg={12}>
                <Sidebar
                  visible={visibleViewRight}
                  position="right"
                  onHide={() => setVisibleViewRight(false)}
                  className="view-form-sidebar"
                >

                  <div className="sidebar-header">
                    <h3 className="head">
                      <i className="pi pi-users"></i> Candidate - Anup Gagoi
                    </h3>
                    <div className="d-flex align-items-center">
                      <Link to="/candidate-editform">
                        <p className="mb-0 text-white">
                          {" "}
                          <i class="fa-regular fa-pen-to-square me-3"></i>{" "}
                        </p>
                      </Link>
                      <Button
                        icon="pi pi-times"
                        className="p-button-text close-btn"
                        onClick={() => setVisibleViewRight(false)}
                      />
                    </div>
                  </div>
                  <TabView className="mt-4">
                    <TabPanel header="Profile" leftIcon="pi pi-user mr-2">
                      <Row>
                        <Col lg={12}>
                          {/* <h5 className="sub-head">Anup Gagoi</h5> */}
                        </Col>
                        <Col lg={12}>
                          <Accordion activeIndex={0}>
                            <AccordionTab
                              header={
                                <span className="flex align-items-center gap-2 w-full">
                                  {/* <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" shape="circle" /> */}
                                  <span className="white-space-nowrap">
                                    PROFILE INFORMATION
                                  </span>
                                  <Badge value="-" className="ml-auto" />
                                </span>
                              }
                            >
                              <Row className="mb-2">
                                <Col lg={4}>
                                  <div className="p-field">
                                    <label htmlFor="fullName" className="block">
                                      Full Name
                                    </label>
                                    <InputText
                                      id="fullName"
                                      value={fullName}
                                      readOnly
                                      onChange={e =>
                                        setFullName(e.target.value)
                                      }
                                      placeholder=""
                                      className="block w-full"
                                    />
                                  </div>
                                </Col>
                                <Col lg={4}>
                                  <div className="p-field">
                                    <label
                                      htmlFor="work-email"
                                      className="block"
                                    >
                                      Email
                                    </label>
                                    <InputText
                                      id="work-email"
                                      value={workEmail}
                                      readOnly
                                      onChange={e =>
                                        setWorkEmail(e.target.value)
                                      }
                                      type="email"
                                      placeholder=""
                                      className="w-full"
                                    />
                                  </div>
                                </Col>
                                <Col lg={4}>
                                  <div className="p-field">
                                    <label
                                      htmlFor="phoneNumber"
                                      className="block"
                                    >
                                      Phone Number
                                    </label>
                                    <InputText
                                      id="phoneNumber"
                                      value={phoneNumber}
                                      readOnly
                                      onChange={e =>
                                        setPhoneNumber(e.target.value)
                                      }
                                      placeholder=""
                                      className="block w-full"
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mb-2">
                                <Col lg={4}>
                                  <div className="p-field">
                                    <label htmlFor="jobTitle" className="block">
                                      Job Title
                                    </label>
                                    <InputText
                                      id="jobTitle"
                                      value={jobTitle}
                                      readOnly
                                      onChange={e =>
                                        setJobTitle(e.target.value)
                                      }
                                      placeholder=""
                                      className="block w-full"
                                    />
                                  </div>
                                </Col>

                                <Col lg={4}>
                                  <div className="p-field">
                                    <label htmlFor="company">Company</label>
                                    <InputText
                                      id="company"
                                      value={company}
                                      readOnly
                                      onChange={e => setCompany(e.target.value)}
                                      placeholder=""
                                      className="block w-full"
                                    />
                                  </div>
                                </Col>
                                <Col lg={4}>
                                  <div className="p-field">
                                    <label className="block">
                                      Primary Skills
                                    </label>
                                    <select
                                      className="form-select mb-1"
                                      value={primarySkills}
                                      readOnly
                                      onChange={e =>
                                        setPrimarySkills(e.target.value)
                                      }
                                    >
                                      <option value="">
                                        Select Primary Skills
                                      </option>

                                    </select>
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mb-2">
                                {/* <Col lg={4}>
                                                                        <label htmlFor="postalCode">Postal Code</label>
                                                                        <InputText
                                                                            id="postalCode"
                                                                            value={postalCode}
                                                                            onChange={(e) => setPostalCode(e.target.value)}
                                                                            placeholder=""
                                                                            className="w-full activejobdrop"
                                                                        />
                                                                    </Col> */}

                                <Col lg={4}>
                                  <div className="p-field">
                                    <label htmlFor="city">City</label>
                                    <InputText
                                      id="city"
                                      value={city}
                                      disabled
                                      onChange={e => setCity(e.target.value)}
                                      placeholder=""
                                      className="block w-full"
                                    />
                                  </div>
                                </Col>
                                <Col lg={4}>
                                  <div className="p-field">
                                    <label
                                      htmlFor="availabilityDate"
                                      className="block"
                                    >
                                      Availability Date
                                    </label>
                                    <Calendar
                                      className="w-100"
                                      id="buttondisplay"
                                      value={availabilityDate1}
                                      disabled
                                      onChange={e =>
                                        setAvailabilityDate1(e.target.value)
                                      }
                                      showIcon
                                    />
                                  </div>
                                </Col>
                                <Col lg={4}>
                                  <div className="p-field">
                                    <label
                                      htmlFor="relocation"
                                      className="block"
                                    >
                                      Relocation
                                    </label>

                                    <input
                                      type="checkbox"
                                      disabled

                                      className="me-2"
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mb-2">
                                <Col lg={4}>
                                  <div className="p-field">
                                    <label htmlFor="jobType">Categories</label>
                                    <TreeSelect
                                      disabled

                                      filter
                                      className=" w-full"
                                      placeholder="Select Item"
                                    ></TreeSelect>
                                  </div>
                                </Col>
                                <Col lg={4}>
                                  <div className="p-field">
                                    <label htmlFor="jobType">Groups</label>
                                    <TreeSelect
                                      disabled

                                      filter
                                      className=" w-full"
                                      placeholder="Select Item"
                                    ></TreeSelect>
                                  </div>
                                </Col>
                                <Col lg={4}>
                                  <div className="p-field">
                                    <label htmlFor="jobType">UserIDs</label>
                                    <InputText
                                      id="userIds"
                                      value={userIds}
                                      disabled
                                      placeholder=""
                                      className="block w-full"
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mb-2"></Row>

                              <Row>
                                <Col lg={12}>
                                  <div className="p-field">
                                    <label htmlFor="jobType" className="block">
                                      Notes
                                    </label>
                                    <InputTextarea
                                      autoResize
                                      value={description}
                                      readOnly
                                      onChange={e =>
                                        setDescription(e.target.value)
                                      }
                                      rows={5}
                                      cols={40}
                                      placeholder=""
                                      className="w-full "
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </AccordionTab>
                            <AccordionTab
                              header={
                                <span className="flex align-items-center gap-2 w-full">
                                  {/* <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/onyamalimba.png" shape="circle" /> */}
                                  <span className="white-space-nowrap">
                                    DOCUMENTS
                                  </span>
                                  <Badge value="-" className="ml-auto" />
                                </span>
                              }
                            >
                              <Row>
                                <Col lg={12}>
                                  <div className="doc-table">
                                    <TreeTable
                                      value={documents}
                                      // header={header}
                                      tableStyle={{ minWidth: "50rem" }}
                                    >
                                      <Column
                                        field="certificate_name"
                                        header="Document Type"
                                      ></Column>
                                      <Column
                                        field="docSubject"
                                        header="Document Subject"
                                      ></Column>
                                      <Column
                                        field="created_at"
                                        header="Applied Date & Time"
                                      ></Column>
                                      {/* <Column body={actionTemplate} headerClassName="w-10rem" header="Actions" /> */}
                                    </TreeTable>
                                  </div>
                                </Col>
                              </Row>
                            </AccordionTab>
                          </Accordion>
                        </Col>
                      </Row>
                    </TabPanel>
                    <TabPanel header="Resume" leftIcon="pi pi-file mr-2">
                      <Row>
                        <Col lg={12}>
                          <div>
                            <Accordion activeIndex={[0, 1]} multiple>
                              <AccordionTab header="Resume">
                                <Row className="resumehead">
                                  <Col lg={12}>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div className="d-flex justify-content-between">
                                        <h6 className="me-2">
                                          Date:{" "}
                                          <span className="date">
                                            2025-01-16
                                          </span>
                                        </h6>
                                        <h6>
                                          UserIDs:{" "}
                                          <span className="date">
                                            SrinivasRao
                                          </span>
                                        </h6>
                                      </div>

                                      <Button
                                        type="submit"
                                        color="primary"
                                        className="btn btn-primary me-2 sidebarbtn"
                                      // onClick={downloadResume}
                                      >
                                        <i class="pi pi-download me-2"></i>
                                        Download Resume
                                      </Button>
                                    </div>
                                  </Col>
                                </Row>

                                <Row
                                  className="resumedetails mt-3"
                                  id="resume-content"
                                >
                                  <Col lg={12}>
                                    <div class="contact">
                                      <h1 className="name">Kiran Chandran</h1>
                                      <p className="role mb-1">
                                        Front end developer
                                      </p>
                                      <div className="d-flex">
                                        <p className="me-3 contact">
                                          <i className="pi pi-phone"></i>{" "}
                                          +91-8309860962
                                        </p>
                                        <p className="me-3 contact">
                                          <i className="pi pi-envelope"></i>{" "}
                                          kiranroyal2000@gmail.com
                                        </p>
                                        <p className="me-3">
                                          <a href="#">
                                            <i className="pi pi-linkedin"></i>{" "}
                                            LinkedIn Profile
                                          </a>
                                        </p>
                                        <p className="me-3">
                                          {" "}
                                          <a href="#">GitHub Profile</a>
                                        </p>
                                      </div>
                                    </div>

                                    <div class="section">
                                      <h2>
                                        <strong>Career Objective</strong>
                                      </h2>
                                      <p>
                                        Dynamic and detail-oriented Front-End
                                        Developer with over 3.1+ years of
                                        experience in building and optimizing
                                        user-focused web applications using
                                        React.js. I am proficient in JavaScript
                                        and skilled in leveraging modern web
                                        development tools and frameworks
                                        including Redux and React Router.
                                        Hands-on experience with RESTful APIs,
                                        microservices architecture, and cloud
                                        services like AWS.
                                      </p>
                                    </div>

                                    <div class="section">
                                      <h2>Skills</h2>
                                      <ul class="skills-list">
                                        <li>
                                          <strong>
                                            Programming Languages:
                                          </strong>{" "}
                                          JavaScript, Java
                                        </li>
                                        <li>
                                          <strong>Web Technologies:</strong>{" "}
                                          HTML, CSS, React.js, Redux, React
                                          Router
                                        </li>
                                        <li>
                                          <strong>Database:</strong> MongoDB
                                        </li>
                                        <li>
                                          <strong>Testing Tools:</strong> Jest,
                                          React Testing Library
                                        </li>
                                        <li>
                                          <strong>API Integration:</strong>{" "}
                                          RESTful Services, Postman
                                        </li>
                                        <li>
                                          <strong>
                                            Project Management & Collaboration:
                                          </strong>{" "}
                                          Jira, Rally
                                        </li>
                                        <li>
                                          <strong>Version Control:</strong> Git
                                        </li>
                                        <li>
                                          <strong>CI/CD Tools:</strong> Jenkins
                                        </li>
                                        <li>
                                          <strong>Cloud Services:</strong>{" "}
                                          Amazon Web Services (AWS)
                                        </li>
                                        <li>
                                          <strong>Architecture:</strong>{" "}
                                          Micro-Services
                                        </li>
                                        <li>
                                          <strong>Content Management:</strong>{" "}
                                          Adobe Experience Manager (AEM)
                                        </li>
                                        <li>
                                          <strong>
                                            Computer Science Fundamentals:
                                          </strong>{" "}
                                          Data Structures
                                        </li>
                                      </ul>
                                    </div>

                                    <div class="section mt-3">
                                      <h2>Work Experience</h2>
                                      <h3>LTIMindtree - Front-End Developer</h3>
                                      <p>(Dec 2021 – Present)</p>
                                      <p>
                                        <strong>Project:</strong> Adidas -
                                        Retail Service Platform (RSP)
                                      </p>
                                      <p>
                                        <strong>Description:</strong> Developed
                                        and optimized user interfaces for an
                                        online retail web application, enhancing
                                        overall user experience and operational
                                        efficiency.
                                      </p>
                                      <h4>Responsibilities:</h4>
                                      <ul class="responsibilities">
                                        <li>
                                          Developed dynamic and responsive
                                          front-end components using React.js
                                          and JavaScript, significantly
                                          improving user engagement.
                                        </li>
                                        <li>
                                          Collaborated with back-end developers
                                          to integrate RESTful APIs, ensuring
                                          seamless data flow between the
                                          front-end and the microservices
                                          architecture.
                                        </li>
                                        <li>
                                          Utilized Redux for state management
                                          and React Router for efficient
                                          client-side routing.
                                        </li>
                                        <li>
                                          Contributed to sprint planning and
                                          retrospectives within an Agile
                                          framework using JIRA, leading to
                                          improved code quality and product
                                          scalability.
                                        </li>
                                        <li>
                                          Worked with MongoDB for efficient data
                                          storage and retrieval.
                                        </li>
                                        <li>
                                          Managed version control and code
                                          collaboration using Git and
                                          streamlined CI/CD processes with
                                          Jenkins.
                                        </li>
                                        <li>
                                          Engaged in troubleshooting and
                                          resolving front-end issues in
                                          collaboration with the QA and
                                          development teams.
                                        </li>
                                      </ul>
                                      <p className="mt-2">
                                        <strong>Technologies Used:</strong>{" "}
                                        JavaScript, React.js, Redux, React
                                        Router, MongoDB, RESTful APIs, Jest,
                                        Git, Jenkins, AWS
                                      </p>
                                    </div>

                                    <div class="section">
                                      <h2>Education</h2>
                                      <p>
                                        Sri Venkateswara College of Engineering
                                        & Technology (Chittoor)
                                        <br />
                                        B. Tech in Electrical & Electronics
                                        Engineering (EEE) - CGPA: 7.65 - (2018 –
                                        2021)
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                              </AccordionTab>
                              <AccordionTab header="Skill Matrix">
                                <p></p>
                              </AccordionTab>
                            </Accordion>
                          </div>
                        </Col>
                      </Row>
                    </TabPanel>
                    <TabPanel header="Pipeline" leftIcon="pi pi-cog mr-2">
                      <Row>
                        <Col lg={12}>
                          <div className="pipelinetabs">
                            <TabView
                              scrollable
                              style={{ maxWidth: "1200px", overflow: "hidden" }}
                            >
                              <TabPanel
                                header="Received"
                                rightIcon={
                                  <Badge value={badgeCounts1.Received} severity="success" className="ml-2" />

                                }
                                leftIcon="pi pi-cog mr-1"
                              >
                                <section className="job-datatable-section">
                                  <div className="card1 mt-3 mb-4 actjobsumtable">
                                    <DataTable
                                      responsive
                                      showGridlines
                                      value={receivedJobs1}
                                      tableStyle={{
                                        minWidth: "60rem",
                                        borderRadius: "8px",
                                        boxShadow:
                                          "0 2px 5px rgba(0, 0, 0, 0.1)",
                                      }}
                                      paginator
                                      rows={10}
                                      rowsPerPageOptions={[5, 10, 25]}
                                      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                      currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                      filters={receivedJobsFilters}
                                      filterDisplay="row"
                                      globalFilterFields={[
                                        "status",
                                        "jobid",
                                        "job_title",
                                        "contact",
                                        "company",
                                        "date_time",
                                        "user_id",
                                      ]}
                                      emptyMessage="No jobs found."
                                      selection={selectedReceivedJobs}
                                      onSelectionChange={e =>
                                        setSelectedReceivedJobs(e.value)
                                      }
                                      selectionMode="multiple"
                                      resizableColumns
                                      columnResizeMode="expand"
                                    >
                                      <Column
                                        selectionMode="multiple"
                                        headerStyle={{ width: "3em" }}
                                      />
                                      <Column
                                        field="status"
                                        header="Status"
                                        sortable
                                        filter
                                        style={{ minWidth: "10rem" }}
                                      />
                                      <Column
                                        field="jobid"
                                        header="Job ID"
                                        sortable
                                        filter
                                        style={{ minWidth: "10rem" }}
                                      />
                                      <Column
                                        field="job_title"
                                        header="Job Title"
                                        sortable
                                        filter
                                        style={{ minWidth: "10rem" }}
                                      />
                                      <Column
                                        field="contact"
                                        header="Contact"
                                        sortable
                                        filter
                                        style={{ minWidth: "10rem" }}
                                      />
                                      <Column
                                        field="company"
                                        header="Company"
                                        sortable
                                        filter
                                        style={{ minWidth: "10rem" }}
                                      />
                                      <Column
                                        field="date_time"
                                        header="Date & Time"
                                        sortable
                                        filter
                                        style={{ minWidth: "12rem" }}
                                      />
                                      <Column
                                        field="user_id"
                                        header="User ID"
                                        sortable
                                        filter
                                        style={{ minWidth: "10rem" }}
                                      />
                                    </DataTable>
                                  </div>
                                </section>
                              </TabPanel>
                              <TabPanel
                                header="Potential"
                                rightIcon={
                                  <Badge value={badgeCounts1.Potential} severity="warning" className="ml-2" />

                                }
                                leftIcon="pi pi-cog mr-1"
                              >
                                <Row>
                                  <Col lg={12}>
                                    <section className="job-datatable-section">
                                      <div className="card1 mt-3 mb-4 actjobsumtable">
                                        <DataTable
                                          responsive
                                          showGridlines
                                          value={potentialJobs1}
                                          tableStyle={{
                                            minWidth: "60rem",
                                            borderRadius: "8px",
                                            boxShadow:
                                              "0 2px 5px rgba(0, 0, 0, 0.1)",
                                          }}
                                          paginator
                                          rows={10}
                                          rowsPerPageOptions={[5, 10, 25]}
                                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                          filters={potentialJobsFilters}
                                          filterDisplay="row"
                                          globalFilterFields={[
                                            "status",
                                            "jobid",
                                            "job_title",
                                            "contact",
                                            "company",
                                            "date_time",
                                            "user_id",
                                          ]}
                                          emptyMessage="No jobs found."
                                          selection={selectedPotentialJobs}
                                          onSelectionChange={e =>
                                            setSelectedPotentialJobs(e.value)
                                          }
                                          selectionMode="multiple"
                                          resizableColumns
                                          columnResizeMode="expand"
                                        >
                                          <Column
                                            selectionMode="multiple"
                                            headerStyle={{ width: "3em" }}
                                          />
                                          <Column
                                            field="status"
                                            header="Status"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="jobid"
                                            header="Job ID"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="job_title"
                                            header="Job Title"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="contact"
                                            header="Contact"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="company"
                                            header="Company"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="date_time"
                                            header="Date & Time"
                                            sortable
                                            filter
                                            style={{ minWidth: "12rem" }}
                                          />
                                          <Column
                                            field="user_id"
                                            header="User ID"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                        </DataTable>
                                      </div>
                                    </section>
                                  </Col>
                                </Row>
                              </TabPanel>
                              <TabPanel
                                header="Submitted"
                                rightIcon={
                                  <Badge value={badgeCounts1.Submitted} severity="warning" className="ml-2" />
                                }
                                leftIcon="pi pi-cog mr-1"
                              >
                                <Row>
                                  <Col lg={12}>
                                    <section className="job-datatable-section">
                                      <div className="card1 mt-3 mb-4 actjobsumtable">
                                        <DataTable
                                          responsive
                                          showGridlines
                                          value={submittedJobs1}
                                          tableStyle={{
                                            minWidth: "60rem",
                                            borderRadius: "8px",
                                            boxShadow:
                                              "0 2px 5px rgba(0, 0, 0, 0.1)",
                                          }}
                                          paginator
                                          rows={10}
                                          rowsPerPageOptions={[5, 10, 25]}
                                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                          filters={submittedJobsFilters}
                                          filterDisplay="row"
                                          globalFilterFields={[
                                            "status",
                                            "jobid",
                                            "job_title",
                                            "contact",
                                            "company",
                                            "date_time",
                                            "user_id",
                                          ]}
                                          emptyMessage="No jobs found."
                                          selection={selectedSubmittedJobs}
                                          onSelectionChange={e =>
                                            setSelectedSubmittedJobs(e.value)
                                          }
                                          selectionMode="multiple"
                                          resizableColumns
                                          columnResizeMode="expand"
                                        >
                                          <Column
                                            selectionMode="multiple"
                                            headerStyle={{ width: "3em" }}
                                          />
                                          <Column
                                            field="status"
                                            header="Status"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="jobid"
                                            header="Job ID"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="job_title"
                                            header="Job Title"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="contact"
                                            header="Contact"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="company"
                                            header="Company"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="date_time"
                                            header="Date & Time"
                                            sortable
                                            filter
                                            style={{ minWidth: "12rem" }}
                                          />
                                          <Column
                                            field="user_id"
                                            header="User ID"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                        </DataTable>
                                      </div>
                                    </section>
                                  </Col>
                                </Row>
                              </TabPanel>
                              <TabPanel
                                header="Offer Accepted"
                                rightIcon={
                                  <Badge value={badgeCounts1.Offer} severity="danger" className="ml-2" />
                                }
                                leftIcon="pi pi-cog mr-1"
                              >
                                <Row>
                                  <Col lg={12}>
                                    <section className="job-datatable-section">
                                      <div className="card1 mt-3 mb-4 actjobsumtable">
                                        <DataTable
                                          responsive
                                          showGridlines
                                          value={offerJobs1}
                                          tableStyle={{
                                            minWidth: "60rem",
                                            borderRadius: "8px",
                                            boxShadow:
                                              "0 2px 5px rgba(0, 0, 0, 0.1)",
                                          }}
                                          paginator
                                          rows={10}
                                          rowsPerPageOptions={[5, 10, 25]}
                                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                          filters={offerJobsFilters}
                                          filterDisplay="row"
                                          globalFilterFields={[
                                            "status",
                                            "jobid",
                                            "job_title",
                                            "contact",
                                            "company",
                                            "date_time",
                                            "user_id",
                                          ]}
                                          emptyMessage="No offers found."
                                          selection={selectedOfferJobs}
                                          onSelectionChange={e =>
                                            setSelectedOfferJobs(e.value)
                                          }
                                          selectionMode="multiple"
                                          resizableColumns
                                          columnResizeMode="expand"
                                        >
                                          <Column
                                            selectionMode="multiple"
                                            headerStyle={{ width: "3em" }}
                                          />
                                          <Column
                                            field="status"
                                            header="Status"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="jobid"
                                            header="Job ID"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="job_title"
                                            header="Job Title"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="contact"
                                            header="Contact"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="company"
                                            header="Company"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="date_time"
                                            header="Date & Time"
                                            sortable
                                            filter
                                            style={{ minWidth: "12rem" }}
                                          />
                                          <Column
                                            field="user_id"
                                            header="User ID"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                        </DataTable>
                                      </div>
                                    </section>
                                  </Col>
                                </Row>
                              </TabPanel>
                              <TabPanel
                                header="Offer Rejected"
                                rightIcon={
                                  <Badge value={badgeCounts1.Rejected} severity="danger" className="ml-2" />

                                }
                                leftIcon="pi pi-cog mr-1"
                              >
                                <Row>
                                  <Col lg={12}>
                                    <section className="job-datatable-section">
                                      <div className="card1 mt-3 mb-4 actjobsumtable">
                                        <DataTable
                                          responsive
                                          showGridlines
                                          value={rejectedJobs1}
                                          tableStyle={{
                                            minWidth: "60rem",
                                            borderRadius: "8px",
                                            boxShadow:
                                              "0 2px 5px rgba(0, 0, 0, 0.1)",
                                          }}
                                          paginator
                                          rows={10}
                                          rowsPerPageOptions={[5, 10, 25]}
                                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                          filters={rejectedJobsFilters}
                                          filterDisplay="row"
                                          globalFilterFields={[
                                            "status",
                                            "jobid",
                                            "job_title",
                                            "contact",
                                            "company",
                                            "date_time",
                                            "user_id",
                                          ]}
                                          emptyMessage="No rejected jobs found."
                                          selection={selectedRejectedJobs}
                                          onSelectionChange={e =>
                                            setSelectedRejectedJobs(e.value)
                                          }
                                          selectionMode="multiple"
                                          resizableColumns
                                          columnResizeMode="expand"
                                        >
                                          <Column
                                            selectionMode="multiple"
                                            headerStyle={{ width: "3em" }}
                                          />
                                          <Column
                                            field="status"
                                            header="Status"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="jobid"
                                            header="Job ID"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="job_title"
                                            header="Job Title"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="contact"
                                            header="Contact"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="company"
                                            header="Company"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="date_time"
                                            header="Date & Time"
                                            sortable
                                            filter
                                            style={{ minWidth: "12rem" }}
                                          />
                                          <Column
                                            field="user_id"
                                            header="User ID"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                        </DataTable>
                                      </div>
                                    </section>
                                  </Col>
                                </Row>
                              </TabPanel>
                              <TabPanel
                                header="Interviews"
                                rightIcon={
                                  <Badge value={badgeCounts1.Interview} severity="danger" className="ml-2" />

                                }
                                leftIcon="pi pi-cog mr-1"
                              >
                                <Row>
                                  <Col lg={12}>
                                    <section className="job-datatable-section">
                                      <div className="card1 mt-3 mb-4 actjobsumtable">
                                        <DataTable
                                          responsive
                                          showGridlines
                                          value={interviewJobs1}
                                          tableStyle={{
                                            minWidth: "60rem",
                                            borderRadius: "8px",
                                            boxShadow:
                                              "0 2px 5px rgba(0, 0, 0, 0.1)",
                                          }}
                                          paginator
                                          rows={10}
                                          rowsPerPageOptions={[5, 10, 25]}
                                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                          filters={interviewJobsFilters}
                                          filterDisplay="row"
                                          globalFilterFields={[
                                            "status",
                                            "jobid",
                                            "job_title",
                                            "contact",
                                            "company",
                                            "date_time",
                                            "user_id",
                                          ]}
                                          emptyMessage="No interview jobs found."
                                          selection={selectedInterviewJobs}
                                          onSelectionChange={e =>
                                            setSelectedInterviewJobs(e.value)
                                          }
                                          selectionMode="multiple"
                                          resizableColumns
                                          columnResizeMode="expand"
                                        >
                                          <Column
                                            selectionMode="multiple"
                                            headerStyle={{ width: "3em" }}
                                          />
                                          <Column
                                            field="status"
                                            header="Status"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="jobid"
                                            header="Job ID"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="job_title"
                                            header="Job Title"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="contact"
                                            header="Contact"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="company"
                                            header="Company"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="date_time"
                                            header="Date & Time"
                                            sortable
                                            filter
                                            style={{ minWidth: "12rem" }}
                                          />
                                          <Column
                                            field="user_id"
                                            header="User ID"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                        </DataTable>
                                      </div>
                                    </section>
                                  </Col>
                                </Row>
                              </TabPanel>
                              <TabPanel
                                header="Placement Closed"
                                rightIcon={
                                  <Badge value={badgeCounts1.Placed} severity="danger" className="ml-2" />

                                }
                                leftIcon="pi pi-cog mr-1"
                              >
                                <Row>
                                  <Col lg={12}>
                                    <section className="job-datatable-section">
                                      <div className="card1 mt-3 mb-4 actjobsumtable">
                                        <DataTable
                                          responsive
                                          showGridlines
                                          value={placedJobs1}
                                          tableStyle={{
                                            minWidth: "60rem",
                                            borderRadius: "8px",
                                            boxShadow:
                                              "0 2px 5px rgba(0, 0, 0, 0.1)",
                                          }}
                                          paginator
                                          rows={10}
                                          rowsPerPageOptions={[5, 10, 25]}
                                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                          filters={placedJobsFilters}
                                          filterDisplay="row"
                                          globalFilterFields={[
                                            "status",
                                            "jobid",
                                            "job_title",
                                            "contact",
                                            "company",
                                            "date_time",
                                            "user_id",
                                          ]}
                                          emptyMessage="No placed jobs found."
                                          selection={selectedPlacedJobs}
                                          onSelectionChange={e =>
                                            setSelectedPlacedJobs(e.value)
                                          }
                                          selectionMode="multiple"
                                          resizableColumns
                                          columnResizeMode="expand"
                                        >
                                          <Column
                                            selectionMode="multiple"
                                            headerStyle={{ width: "3em" }}
                                          />
                                          <Column
                                            field="status"
                                            header="Status"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="jobid"
                                            header="Job ID"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="job_title"
                                            header="Job Title"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="contact"
                                            header="Contact"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="company"
                                            header="Company"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                          <Column
                                            field="date_time"
                                            header="Date & Time"
                                            sortable
                                            filter
                                            style={{ minWidth: "12rem" }}
                                          />
                                          <Column
                                            field="user_id"
                                            header="User ID"
                                            sortable
                                            filter
                                            style={{ minWidth: "10rem" }}
                                          />
                                        </DataTable>
                                      </div>
                                    </section>
                                  </Col>
                                </Row>
                              </TabPanel>
                            </TabView>
                          </div>
                        </Col>
                      </Row>
                    </TabPanel>
                    <TabPanel
                      header="Activities"
                      leftIcon="pi pi-calendar mr-2"
                    >
                      <Row>
                        <Col lg={12}>
                          <section className="job-datatable-section">
                            <div className="card1 mt-3 mb-4 actjobsumtable">
                              <DataTable
                                responsive
                                showGridlines
                                // value={activities}
                                tableStyle={{
                                  minWidth: "50rem",
                                  borderRadius: "8px",
                                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                                }}
                                paginator
                                rows={5}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                // filters={activitiesFilters}
                                filterDisplay="row"
                                globalFilterFields={[
                                  "type",
                                  "sub_type",
                                  "priority",
                                  "subject",
                                  "date_time",
                                  "user_id",
                                ]}
                                emptyMessage="No activities found."
                                // selection={selectedActivities}
                                // onSelectionChange={e =>
                                //   setSelectedActivities(e.value)
                                // }
                                selectionMode="multiple"
                                resizableColumns
                                columnResizeMode="expand"
                              >
                                <Column
                                  selectionMode="multiple"
                                  headerStyle={{ width: "3em" }}
                                />
                                <Column
                                  field="type"
                                  header="Type"
                                  sortable
                                  filter
                                  style={{ minWidth: "10rem" }}
                                />
                                <Column
                                  field="sub_type"
                                  header="Sub Type"
                                  sortable
                                  filter
                                  style={{ minWidth: "10rem" }}
                                />
                                <Column
                                  field="priority"
                                  header="Priority"
                                  sortable
                                  filter
                                  style={{ minWidth: "10rem" }}
                                />
                                <Column
                                  field="subject"
                                  header="Subject"
                                  sortable
                                  filter
                                  style={{ minWidth: "10rem" }}
                                />
                                <Column
                                  field="date_time"
                                  header="Date and Time"
                                  sortable
                                  filter
                                  style={{ minWidth: "10rem" }}
                                />
                                <Column
                                  field="user_id"
                                  header="User ID"
                                  sortable
                                  filter
                                  style={{ minWidth: "10rem" }}
                                />
                              </DataTable>
                            </div>
                          </section>
                        </Col>
                      </Row>
                    </TabPanel>
                    <TabPanel header="History" leftIcon="pi pi-clock mr-2">
                      <Row>
                        <Col lg={12} sm={12}>
                          <section className="job-datatable-section">
                            <div className="card1 mt-3 mb-4 actjobsumtable">
                              <DataTable
                                responsive
                                showGridlines
                                // value={activities}
                                tableStyle={{
                                  minWidth: "50rem",
                                  borderRadius: "8px",
                                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                                }}
                                paginator
                                rows={5}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                // filters={activitiesFilters}
                                filterDisplay="row"
                                globalFilterFields={[
                                  "type",
                                  "sub_type",
                                  "priority",
                                  "subject",
                                  "date_time",
                                  "user_id",
                                ]}
                                emptyMessage="No activities found."
                                // selection={selectedActivities}
                                // onSelectionChange={e =>
                                //   setSelectedActivities(e.value)
                                // }
                                selectionMode="multiple"
                                resizableColumns
                                columnResizeMode="expand"

                              >
                                <Column selectionMode="multiple" headerStyle={{ width: "3em" }} />
                                <Column
                                  field="type"
                                  header="Type"
                                  sortable
                                  filter
                                  style={{ minWidth: "10rem" }}
                                />
                                <Column
                                  field="sub_type"
                                  header="Sub Type"
                                  sortable
                                  filter
                                  style={{ minWidth: "10rem" }}
                                />
                                <Column
                                  field="priority"
                                  header="Priority"
                                  sortable
                                  filter
                                  style={{ minWidth: "10rem" }}
                                />
                                <Column
                                  field="subject"
                                  header="Subject"
                                  sortable
                                  filter
                                  style={{ minWidth: "10rem" }}
                                />
                                <Column
                                  field="date_time"
                                  header="Date and Time"
                                  sortable
                                  filter
                                  style={{ minWidth: "10rem" }}
                                />
                                <Column
                                  field="user_id"
                                  header="User ID"
                                  sortable
                                  filter
                                  style={{ minWidth: "10rem" }}
                                />
                              </DataTable>
                            </div>
                          </section>
                        </Col>
                      </Row>
                    </TabPanel>
                    <TabPanel header="Notes" leftIcon="pi pi-pencil mr-2">
                      <Row>
                        <Col lg={12}>
                          <div className="d-flex justify-content-end">
                            <Button
                              type="button"
                              label="Add Notes"
                              icon="pi pi-plus"
                              className="btn btn-primary waves-effect waves-light me-2 sidebarbtn"
                            //   onClick={handleAddNotes}
                            />
                          </div>
                        </Col>
                      </Row>

                      {isEditorVisible && (
                        <Row className="mt-4">
                          <Col lg={12}>
                            <Editor
                              value={editorContent}
                              onTextChange={e => setEditorContent(e.htmlValue)}
                              style={{ height: "200px" }}
                              placeholder="Enter your notes here..."
                            />
                            <div className="d-flex justify-content-end mt-2">
                              <Button
                                type="button"
                                label="Save"
                                icon="pi pi-save"
                                className="btn btn-success me-2"
                                onClick={handleSaveNotes}
                              />
                              <Button
                                color="primary"
                                className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                                onClick={handleCancelNotes}
                              >
                                <i className="pi pi-times me-1"></i>
                                Cancel
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      )}

                      <Row className="mt-4 notes">
                        <Col lg={12}>
                          {candidateNotes.length > 0 && (
                            <Card className="pt-0 pb-0">
                              {candidateNotes.map((note, index) => (
                                <div key={index}>
                                  <div className="d-flex mt-0">
                                    <strong className="text-muted me-4">
                                      {note.candidateName}
                                    </strong>
                                    <strong className="text-muted">
                                      {note.timestamp}
                                    </strong>
                                  </div>
                                  <div className="d-flex justify-content-between mt-2 mb-0">
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: note.content,
                                      }}
                                    />
                                    <div>
                                      <Button
                                        icon="pi pi-pencil"
                                        className="btn btn-warning editbtn p-0"
                                        onClick={() => handleEditNote(index)}
                                      />
                                      <Button
                                        icon="pi pi-trash"
                                        className="btn btn-danger deletebtn"
                                        onClick={() => handleDeleteNote(index)}
                                      />
                                    </div>
                                  </div>
                                  <hr />
                                </div>
                              ))}
                            </Card>
                          )}
                        </Col>
                      </Row>
                    </TabPanel>
                  </TabView>
                </Sidebar>
              </Col>
            </Row>
            {/* view employee end */}
          </div>

        </Container>
      </div>

      <Dialog visible={successAlert} style={{ width: "450px" }} header="Confirm Deletion" modal onHide={() => setsuccessAlert(false)}>
        <p>Delete  Successfully</p>
        <div>
          <button type="button" className="btn btn-secondary" onClick={() => { setsuccessAlert(false) }}>
            OK
          </button>

        </div>
      </Dialog>
    </React.Fragment>
  )
}

export default TableView
